document.addEventListener('DOMContentLoaded', () => {
  const imageStack = document.querySelector('.pb-trap-image-stack');
  const interactiveElements = document.querySelectorAll('#pb-hotspots-app [data-id]');
  let pinnedId = null;

  function isMobile() {
    return window.innerWidth < 768;
  }

  function handleMouseEnter(e) {
    if (isMobile()) return;
    const id = e.target.getAttribute('data-id');
    document.querySelectorAll(`#pb-hotspots-app [data-id="${id}"]`).forEach(match => {
      match.classList.add('is-hovered');
    });
    const layer = document.querySelector(`#pb-hotspots-app .pb-trap-layer[data-id="${id}"]`);
    if (layer) layer.classList.add('is-visible');
    if (imageStack) imageStack.classList.add('is-feature-active');
  }

  function handleMouseLeave(e) {
    if (isMobile()) return;
    const id = e.target.getAttribute('data-id');
    document.querySelectorAll(`#pb-hotspots-app [data-id="${id}"]`).forEach(match => {
      match.classList.remove('is-hovered');
    });
    const layer = document.querySelector(`#pb-hotspots-app .pb-trap-layer[data-id="${id}"]`);
    if (layer) layer.classList.remove('is-visible');
    if (imageStack) imageStack.classList.remove('is-feature-active');
  }

  function activateFeature(id) {
    if (!id) return;
    pinnedId = id;

    document.querySelectorAll('#pb-hotspots-app [data-id]')
      .forEach(el => el.classList.remove('is-hovered'));
    document.querySelectorAll('#pb-hotspots-app .pb-trap-layer')
      .forEach(layer => layer.classList.remove('is-visible'));

    document.querySelectorAll(`#pb-hotspots-app [data-id="${id}"]`)
      .forEach(match => match.classList.add('is-hovered'));
    const layer = document.querySelector(`#pb-hotspots-app .pb-trap-layer[data-id="${id}"]`);
    if (layer) layer.classList.add('is-visible');
    if (imageStack) imageStack.classList.add('is-feature-active');
  }

  function clearPinnedFeature() {
    if (pinnedId === null) return;
    document.querySelectorAll(`#pb-hotspots-app [data-id="${pinnedId}"]`)
      .forEach(el => el.classList.remove('is-hovered'));
    const layer = document.querySelector(`#pb-hotspots-app .pb-trap-layer[data-id="${pinnedId}"]`);
    if (layer) layer.classList.remove('is-visible');
    if (imageStack) imageStack.classList.remove('is-feature-active');
    pinnedId = null;
  }

  function handleHotspotClick(e) {
    const id = e.currentTarget.getAttribute('data-id');
    if (isMobile()) {
      e.preventDefault();
      if (pinnedId === id) handleOpenModal(e);
      else activateFeature(id);
      return;
    }
    handleOpenModal(e);
  }

  interactiveElements.forEach((el) => {
    el.addEventListener('mouseenter', handleMouseEnter);
    el.addEventListener('mouseleave', handleMouseLeave);
    if (el.classList.contains('pb-hotspot'))
      el.addEventListener('click', handleHotspotClick);
    else el.addEventListener('click', handleOpenModal);
  });

  function handleOutsideClick(e) {
    if (pinnedId !== null && !e.target.closest('[data-id]')) {
      clearPinnedFeature();
    }
  }

  document.addEventListener('click', handleOutsideClick);
  document.addEventListener('touchstart', handleOutsideClick, { passive: true });

  const modal = document.getElementById('pb-feature-modal');
  const closeBtn = document.querySelector('.pb-modal-close');
  const modalTitle = document.getElementById('pb-modal-title');
  const modalDescription = document.getElementById('pb-modal-description');
  const modalWhyItMatters = document.getElementById('pb-modal-why-it-matters');

  function isVideoUrl(url) {
    return typeof url === 'string' && /vimeo\.com/i.test(url);
  }

  function getVimeoEmbedUrl(vimeoUrl) {
    const m = /vimeo\.com\/(?:video\/)?(\d+)/i.exec(vimeoUrl);
    return m ? `https://player.vimeo.com/video/${m[1]}?autoplay=1&muted=0` : '';
  }

  // Modal content keyed by feature id to match button order
  const featureData = {
    1: {
      title: "Trap smarter. <strong>Sleep better.</strong>",
      description: "Encourages 360\u00b0 entry so hogs can root under and enter naturally from any direction. No gates to spook them. No triggers to fail. No signal to depend on.",
      photoUrl: "https://vimeo.com/1165796443?share=copy&fl=sv&fe=ci",
      whyItMatters: "More natural entry, more time open, more opportunity for whole-sounder capture."
    },
    2: {
      title: "<strong>Holds shape</strong> when the action heats up.",
      description: "Essential tension straps help maintain the bowl shape and prevent sagging during high pressure. They create a trampoline effect so hogs hit the net and bounce back in, not up and out.",
      photoUrl: "/cdn/shop/t/45/assets/hotspots-mid-post-cam-straps-modal.jpg",
      whyItMatters: "Structure is security when a full sounder is testing the system."
    },
    3: {
      title: "Built for rooting. <strong>Ready for pressure.</strong>",
      description: "Hogs enter by rooting under the edge. When they get unsettled and hit the side of the net, internal anchor stakes keep the system on the ground, stable, and secure.",
      photoUrl: "/cdn/shop/t/45/assets/hotspots-internal-anchor-stakes-modal.jpg",
      whyItMatters: "Containment is what makes whole-sounder removal possible."
    },
    4: {
      title: "Uncompromised <strong>structural integrity.</strong>",
      description: "We tested fewer. Ten won. This rigid setup is built to handle the chaotic pressure of a fully trapped sounder.",
      photoUrl: "/cdn/shop/t/45/assets/hotspots-t-posts-modal.jpg",
      whyItMatters: "Stands its ground so you can trap with confidence."
    },
    5: {
      title: "Field-proven <strong>under pressure.</strong>",
      description: "Two layers, two jobs. The inner Boar Shield is knotless, heavy duty netting built to resist abrasion and deter chewing. The outer net helps the trap hold its structure under pressure, using durable, UV-resistant netting made for big boars and hard country.",
      photoUrl: "/cdn/shop/t/45/assets/hotspots-double-walled-netting-modal.png",
      whyItMatters: "Built to take hits and keep working set after set."
    },
    6: {
      title: "Keep jumpers <strong>where they belong.</strong>",
      description: "A 2-foot-wide cap that covers about 30% of the opening to discourage \u201Cjumpers\u201D and keep hogs inside once the pressure hits. It clips on or can be sewn in, depending on how you run your trap.",
      photoUrl: "/cdn/shop/t/45/assets/hotspots-trap-cap-modal.png",
      whyItMatters: "Extra containment when you need it. Optional by design, because not every property or sounder behavior calls for the same setup."
    },
    7: {
      title: "<strong>Refuses</strong> to give.",
      description: "Custom-woven polysteel rope is sewn into the sides to keep the system taut and secure through extreme tension and changing weather.",
      photoUrl: "/cdn/shop/t/45/assets/hotspots-polysteel-topline-modal.png",
      whyItMatters: "Less sag, more consistent shape, better performance night after night."
    },
    8: {
      title: "Lorem <strong>ipsum.</strong>",
      description: "Dolor sit amet.",
      photoUrl: "https://placehold.co/670x523",
      whyItMatters: "Consectetuer adipiscing elit."
    }
  };

  // Preload modal images so they're cached before the user opens a modal.
  Object.values(featureData).forEach((data) => {
    const url = data.photoUrl;
    if (url && !isVideoUrl(url)) {
      const img = new Image();
      img.src = url;
    }
  });

  const modalMainImg = document.querySelector('.pb-modal-main-img');
  const modalVideoWrap = document.querySelector('.pb-modal-video-wrap');
  const modalVideoIframe = modalVideoWrap ? modalVideoWrap.querySelector('iframe') : null;

  // Preload the Vimeo embed so it's ready when the user opens the video modal.
  const videoFeature = Object.values(featureData).find((d) => d.photoUrl && isVideoUrl(d.photoUrl));
  if (videoFeature && modalVideoIframe) {
    modalVideoIframe.src = getVimeoEmbedUrl(videoFeature.photoUrl);
  }

  function handleOpenModal(e) {
    const id = e.target.getAttribute('data-id');
    const data = featureData[id];
    if (!data) return;

    if (modalTitle) modalTitle.innerHTML = data.title;
    if (modalDescription) modalDescription.innerHTML = data.description;
    if (modalWhyItMatters) modalWhyItMatters.textContent = data.whyItMatters || '';

    const url = data.photoUrl || '';
    const showVideo = isVideoUrl(url);

    if (showVideo && modalVideoWrap && modalVideoIframe) {
      modalVideoIframe.src = getVimeoEmbedUrl(url);
      modalVideoWrap.classList.add('is-visible');
      modalVideoWrap.setAttribute('aria-hidden', 'false');
      if (modalMainImg) {
        modalMainImg.style.display = 'none';
        modalMainImg.removeAttribute('src');
      }
    } else {
      if (modalVideoWrap) {
        modalVideoWrap.classList.remove('is-visible');
        modalVideoWrap.setAttribute('aria-hidden', 'true');
        if (modalVideoIframe) modalVideoIframe.src = '';
      }
      if (modalMainImg) {
        modalMainImg.style.display = '';
        modalMainImg.src = url;
      }
    }

    modal.classList.add('is-visible');
  }

  function closeModal() {
    modal.classList.remove('is-visible');
    if (modalVideoIframe) modalVideoIframe.src = '';
    clearPinnedFeature();
  }

  if (closeBtn) closeBtn.addEventListener('click', closeModal);

  if (modal)
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
    });

  document.addEventListener('keydown', (e) => {
    if (modal && e.key === 'Escape' && modal.classList.contains('is-visible'))
      closeModal();
  });

  // Scroll Arrow Logic
  const arrowContainer = document.querySelector('.pb-scroll-arrow-container');
  const cardsContainer = document.querySelector('.pb-cards-container');
  const footer = document.querySelector('.pb-footer');

  function updateArrowPosition() {
    if (!arrowContainer || !cardsContainer || !footer) return;

    const arrowHeight = arrowContainer.offsetHeight || 50;
    const viewportHeight = window.innerHeight;
    
    const cardsRect = cardsContainer.getBoundingClientRect();
    const footerRect = footer.getBoundingClientRect();
    const footerStyle = window.getComputedStyle(footer);
    const footerMarginTop = parseFloat(footerStyle.marginTop) || 0;
    
    const minTop = cardsRect.bottom + 20; 
    const maxBottom = footerRect.top - footerMarginTop;
    const idealTop = viewportHeight - arrowHeight - 20;

    let finalTop = idealTop;
    if (finalTop < minTop) finalTop = minTop;
    if (finalTop + arrowHeight > maxBottom) finalTop = maxBottom - arrowHeight;
    
    if (minTop > maxBottom - arrowHeight) {
       arrowContainer.style.opacity = '0';
       arrowContainer.style.pointerEvents = 'none';
    }
    else {
       arrowContainer.style.opacity = '1';
       arrowContainer.style.pointerEvents = 'auto';
       arrowContainer.style.top = `${finalTop}px`;
       arrowContainer.style.bottom = 'auto';
    }
  }

  window.addEventListener('scroll', updateArrowPosition);
  window.addEventListener('resize', updateArrowPosition);
  updateArrowPosition();
  window.addEventListener('load', updateArrowPosition);
});
